import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { Route } from 'react-router-dom';

import { MyContactDetailsPage } from './MyContactDetailsPage/MyContactDetailsPage';
import { MyContactsViewPage } from './MyContactsViewPage';
import { MyContactsAddNewPage } from './MyContactsAddNewPage';
import { MyContactDetailsEditPage } from './MyContactDetailsEditPage';
import { ContactsResponseDto } from './types';
import {
  GET_CONTACTS_QUERY_KEY,
  mapContacts,
  mapUserContactGroups,
} from './utils';
import { api } from 'theSource/utils';
import { Loader, RoutesInternal } from 'theSource/components';

export const MyContacts = () => {
  const { data, isLoading: isLoadingContacts } = useQuery<ContactsResponseDto>(
    GET_CONTACTS_QUERY_KEY,
    () => api.get<ContactsResponseDto>('/contacts/sync')
  );

  const contacts = useMemo(() => data && mapContacts(data.contacts), [data]);

  const isLoading = isLoadingContacts || !contacts;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <RoutesInternal>
      <Route path="/" element={<MyContactsViewPage data={contacts} />} />
      <Route
        path="/new"
        element={
          <MyContactsAddNewPage existingGroups={mapUserContactGroups(contacts)} />
        }
      />
      <Route
        path=":contactId"
        element={<MyContactDetailsPage data={contacts} />}
      />
      <Route
        path=":contactId/edit"
        element={
          <MyContactDetailsEditPage
            data={contacts}
            existingGroups={mapUserContactGroups(contacts)}
          />
        }
      />
    </RoutesInternal>
  );
};
